// jot_ta · su logo de Halloween como pieza sólida en 3D que gira, en la puerta de la tienda (la página con contraseña).
// Lo pidió Jota en la llamada del 20-oct: «sacarlo en 3D entero, como si fuera una pieza de 3D, y girarlo. Sólida», con
// «el brillito cambiando», como las cartas. Viene del boceto (prototipo/boceto/halloween-3d.js).
// Extruye el contorno del dibujo (halloween-forma.js): el dibujo delante, metal oscuro detrás y en el canto, y un brillo
// iridiscente que cambia al girar. Desde el logo nuevo (21-oct), el dibujo es holográfico como las cartas: un arcoíris pastel
// en diagonal que corre al girarlo y al inclinarlo. (Detrás no va el dibujo: la silueta se ve en espejo y el dibujo no casaría con ella.)
// Gira sola, se para un poco cuando mira de frente, se arrastra
// con el ratón o el dedo y se inclina hacia el puntero. Sin WebGL o sin poder leer la imagen, se queda el banner plano.
// Va después de three.js (r149, la última que se carga como script normal; licencia MIT).
//   Pieza3D.montar(caja, { src, forma })  → la caja lleva dentro la <img> plana, que hace de reserva
window.Pieza3D = (() => {
  const quieto = matchMedia('(prefers-reduced-motion: reduce)')

  function montar(caja, { src, forma, grosor = 0.085, vuelta = 9 } = {}) {
    const T = window.THREE
    if (!T || !forma || !caja) return null
    let renderer
    try { renderer = new T.WebGLRenderer({ antialias: true, alpha: true, powerPreference: 'high-performance' }) } catch (e) { return null }
    renderer.outputEncoding = T.sRGBEncoding
    renderer.toneMapping = T.ACESFilmicToneMapping
    renderer.toneMappingExposure = 1.05
    renderer.setClearColor(0x000000, 0)
    const lienzo = renderer.domElement
    lienzo.className = 'pieza3d__lienzo'
    lienzo.setAttribute('aria-hidden', 'true')

    // ── la forma: el contorno del dibujo, de 0 a 1, con la y hacia arriba; ancho = proporción del banner
    const asp = forma.ancho / forma.alto
    const v2 = (p) => new T.Vector2(p[0] * asp, 1 - p[1])
    const figura = new T.Shape(forma.exterior.map(v2))
    for (const h of forma.huecos || []) figura.holes.push(new T.Path(h.map(v2)))
    const geo = new T.ExtrudeGeometry(figura, { depth: grosor, bevelEnabled: true, bevelThickness: 0.014, bevelSize: 0.009, bevelSegments: 4, curveSegments: 1 })
    // las tapas (grupo 0): primero la de atrás y luego la de delante. La de delante lleva el dibujo (u de 0 a 1); la de
    // atrás pasa a su propio grupo, de metal
    const uv = geo.attributes.uv, pos = geo.attributes.position, tapas = geo.groups.find((g) => g.materialIndex === 0)
    const lados = geo.groups.find((g) => g.materialIndex === 1)
    let corte = tapas.start
    while (corte < tapas.start + tapas.count && pos.getZ(corte) < grosor / 2) corte++
    for (let i = tapas.start; i < tapas.start + tapas.count; i++) uv.setX(i, uv.getX(i) / asp)
    uv.needsUpdate = true
    geo.clearGroups()
    geo.addGroup(tapas.start, corte - tapas.start, 2)          // detrás
    geo.addGroup(corte, tapas.start + tapas.count - corte, 0)  // delante, con el dibujo
    geo.addGroup(lados.start, lados.count, 1)                  // el canto
    geo.translate(-asp / 2, -0.5, -grosor / 2)

    // ── la escena: estudio con cajas de luz para los reflejos (y un toque morado y naranja, de Halloween)
    const escena = new T.Scene()
    const pmrem = new T.PMREMGenerator(renderer)
    const estudio = new T.Scene()
    estudio.add(new T.Mesh(new T.BoxGeometry(12, 12, 12), new T.MeshBasicMaterial({ color: 0x15121a, side: T.BackSide })))
    const luz = (w, h, color, k, x, y, z) => {
      const m = new T.Mesh(new T.PlaneGeometry(w, h), new T.MeshBasicMaterial({ color: new T.Color(color).multiplyScalar(k), side: T.DoubleSide }))
      m.position.set(x, y, z); m.lookAt(0, 0, 0); estudio.add(m)
    }
    luz(7, 1.4, 0xffffff, 5, 0, 4, 2.5)     // caja de luz de arriba
    luz(1.3, 6, 0xffffff, 3.2, -5, 0.5, 1.5) // tira de la izquierda
    luz(1.3, 6, 0xffffff, 2.4, 5, 0, 2.5)    // tira de la derecha
    luz(4, 4, 0x8b5cff, 2, -3, -2.5, -4)     // morado, detrás
    luz(4, 4, 0xff7a2f, 1.6, 3.5, -3, -3)    // naranja, detrás
    escena.environment = pmrem.fromScene(estudio, 0.025).texture
    escena.add(new T.AmbientLight(0xffffff, 0.25))
    const sol = new T.DirectionalLight(0xffffff, 0.8); sol.position.set(2, 3, 5); escena.add(sol)

    const textura = new T.Texture()
    textura.encoding = T.sRGBEncoding
    textura.anisotropy = renderer.capabilities.getMaxAnisotropy()
    const dibujo = new T.MeshPhysicalMaterial({
      map: textura, emissive: 0xffffff, emissiveMap: textura, emissiveIntensity: 0.5,
      roughness: 0.38, metalness: 0, clearcoat: 1, clearcoatRoughness: 0.1,
      iridescence: 0.6, iridescenceIOR: 1.55, iridescenceThicknessRange: [140, 560], envMapIntensity: 0.3,
    })
    // holográfico, como las cartas (lo propuso Jorge el 21-oct con el logo nuevo). El dibujo, con sus colores de verdad (sin
    // la luz de la escena ni el tono, que lo lavaban: medido de frente, el contorno y Gengar quedan a unos 15 de 255 de su
    // dibujo); encima, un arcoíris pastel en diagonal en «color-dodge», como el de las cartas (más vivo en lo claro y casi
    // nada en lo oscuro), que corre con el giro y la inclinación; y una franja de luz que cruza el logo al girar, como el
    // reflejo que corre por las cartas, más los brillos del barniz. El entorno refleja poco: si no, el logo se ve lechoso
    const holo = { value: 0 }, fuerza = { value: 0.32 }, brillo = { value: 0 }, incl = { value: 0 }
    dibujo.toneMapped = false
    dibujo.onBeforeCompile = (s) => {
      Object.assign(s.uniforms, { uHolo: holo, uFuerza: fuerza, uBrillo: brillo, uIncl: incl })
      s.fragmentShader = 'uniform float uHolo;\nuniform float uFuerza;\nuniform float uBrillo;\nuniform float uIncl;\n' + s.fragmentShader.replace('#include <output_fragment>', `{
        float ndv = clamp(dot(normalize(normal), normalize(vViewPosition)), 0.0, 1.0);
        float f = (vUv.x * 1.6 - vUv.y * 0.7) + uHolo + ndv * 1.6;
        vec3 arco = 0.62 + 0.38 * cos(6.2832 * (f + vec3(0.0, 0.33, 0.67)));
        float d = (vUv.x - 0.5 - uBrillo * 1.8 - uIncl * 0.8) + (vUv.y - 0.5) * 0.45;
        outgoingLight = min(diffuseColor.rgb / max(vec3(0.02), 1.0 - arco * uFuerza), vec3(1.0)) + totalSpecular * 0.4 + exp(-d * d / 0.012) * 0.32;
        #ifdef USE_CLEARCOAT
          outgoingLight += clearcoatSpecular * material.clearcoat * 0.8;
        #endif
      }
      #include <output_fragment>`)
    }
    const canto = new T.MeshPhysicalMaterial({ color: 0x3b2f4c, metalness: 1, roughness: 0.2, iridescence: 0.45, iridescenceIOR: 1.4, envMapIntensity: 1.35 })
    const trasera = new T.MeshPhysicalMaterial({ color: 0x241d2e, metalness: 0.9, roughness: 0.32, iridescence: 0.5, iridescenceIOR: 1.4, envMapIntensity: 1.2 })
    const pieza = new T.Mesh(geo, [dibujo, canto, trasera])
    escena.add(pieza)
    const camara = new T.PerspectiveCamera(15, 1, 0.1, 80) // poca perspectiva: al girar, el extremo cercano no crece tanto

    // ── tamaño. El lienzo es más grande que la caja (ver .pieza3d__lienzo): al girar, el extremo que se acerca a la cámara
    // crece por la perspectiva y, si el lienzo fuera la caja, se cortaría (lo vio Jorge el 20-oct). La cámara encaja el
    // banner de frente en la caja; el margen del lienzo es para el giro.
    function medir() {
      const rc = lienzo.getBoundingClientRect(), rb = caja.getBoundingClientRect()
      const w = Math.max(1, Math.round(rc.width)), h = Math.max(1, Math.round(rc.height))
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2)); renderer.setSize(w, h, false)
      camara.aspect = w / h
      const t = Math.tan(T.MathUtils.degToRad(camara.fov / 2))
      const d = Math.max((asp * 1.08 * h) / (2 * t * Math.max(1, rb.width)), (1.2 * h) / (2 * t * Math.max(1, rb.height)))
      camara.position.set(0, 0, d + grosor)
      camara.updateProjectionMatrix()
    }

    // ── el giro: solo (se para un poco de frente y de espaldas), arrastrado con inercia, e inclinado hacia el puntero
    const w = (2 * Math.PI) / vuelta
    let fase = 0, extra = 0, inercia = 0, pulsado = null, ultimo = 0, visible = false, raf = 0, lista = false
    let inclX = 0, inclY = 0, objX = 0, objY = 0
    function paso(ahora) {
      raf = 0
      const dt = Math.min(0.05, (ahora - (ultimo || ahora)) / 1000); ultimo = ahora
      if (!pulsado) {
        extra += inercia * dt; inercia *= Math.pow(0.05, dt)
        if (Math.abs(inercia) < 0.08 && !quieto.matches) fase += w * dt
      }
      inclX += (objX - inclX) * (1 - Math.pow(0.002, dt)); inclY += (objY - inclY) * (1 - Math.pow(0.002, dt))
      pieza.rotation.y = fase - 0.62 * Math.sin(fase) + extra + inclY // despacio de frente, rápido por detrás
      pieza.rotation.x = inclX
      holo.value = (((pieza.rotation.y * 0.22 + inclX * 0.8) % 1) + 1) % 1 // el arcoíris corre con el giro (el patrón se repite cada 1)
      brillo.value = Math.sin(pieza.rotation.y); incl.value = inclX // la franja de luz cruza el logo al pasar de frente
      renderer.render(escena, camara)
      if (visible && !document.hidden) raf = requestAnimationFrame(paso)
    }
    const seguir = () => { if (lista && visible && !raf) { ultimo = 0; raf = requestAnimationFrame(paso) } }

    // el arrastre va en la caja: el lienzo es más grande y no recoge el puntero (no tapa los botones de debajo). Sin el
    // arrastre del navegador: si no, con el ratón se arrastra la imagen de reserva como si fuera un archivo
    caja.addEventListener('dragstart', (e) => e.preventDefault())
    caja.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse') e.preventDefault()
      pulsado = { x: e.clientX, t: performance.now(), id: e.pointerId }; inercia = 0
      try { caja.setPointerCapture(e.pointerId) } catch (er) {}
    })
    caja.addEventListener('pointermove', (e) => {
      if (!pulsado || e.pointerId !== pulsado.id) return
      const ahora = performance.now(), dx = e.clientX - pulsado.x, giro = (dx / Math.max(200, caja.clientWidth)) * Math.PI * 1.6
      extra += giro; inercia = 0.7 * inercia + 0.3 * (giro / Math.max(0.008, (ahora - pulsado.t) / 1000))
      pulsado.x = e.clientX; pulsado.t = ahora
    })
    const soltar = () => { pulsado = null }
    caja.addEventListener('pointerup', soltar); caja.addEventListener('pointercancel', soltar)
    addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse') return
      const r = caja.getBoundingClientRect()
      objX = Math.max(-1, Math.min(1, (e.clientY - (r.top + r.height / 2)) / (r.height * 2))) * 0.22
      objY = Math.max(-1, Math.min(1, (e.clientX - (r.left + r.width / 2)) / r.width)) * 0.3
    }, { passive: true })
    document.addEventListener('visibilitychange', seguir)
    new IntersectionObserver((es) => { visible = es[0].isIntersecting; seguir() }, { rootMargin: '60px' }).observe(caja)
    if ('ResizeObserver' in window) new ResizeObserver(() => { medir(); if (lista && !raf) renderer.render(escena, camara) }).observe(caja)

    // ── el dibujo: se comprueba que se puede leer (desde file:// el navegador no deja subirlo a WebGL) y se enciende
    const img = new Image()
    img.onload = () => {
      try {
        const c = document.createElement('canvas'); c.width = c.height = 2
        const x = c.getContext('2d'); x.drawImage(img, 0, 0, 2, 2); x.getImageData(0, 0, 1, 1)
      } catch (e) { return }
      textura.image = img; textura.needsUpdate = true
      caja.appendChild(lienzo); medir()
      renderer.render(escena, camara)
      caja.classList.add('pieza3d--lista'); lista = true; seguir()
    }
    img.crossOrigin = 'anonymous' // en Shopify la imagen sale de su CDN: sin esto, WebGL no la puede leer
    img.src = src
    return { medir, renderer, pieza, camara, escena, holo, fuerza, brillo, incl } // para las pruebas (que no se corte en ningún giro y cómo brilla)
  }
  return { montar }
})()
